import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { ProjectService } from '@connect-services/client/services/project.service';
import { ProjectCreationEditionForm } from '@connect-services/client/services/project/shaping/shaping-project.service';
import {
    ProjectDefaultData,
    ShapingProjectState,
} from '@connect-services/client/services/project/shaping/shaping-state/shaping-project-state';

@Injectable({
    providedIn: 'root',
})
export class CreateProjectShapingStateService extends ShapingProjectState {
    public form!: ProjectCreationEditionForm;
    public title: string = 'createNewProject';

    private readonly projectService = inject(ProjectService);
    private readonly router = inject(Router);

    public clear(): void {
        this.defaultData = undefined;
        this.form.reset();
    }

    public getDefaultData(): ProjectDefaultData | undefined {
        return this.defaultData;
    }

    public async onConfirm(form: ProjectCreationEditionForm): Promise<void> {
        const projectId = await this.projectService.createProject(form);

        await this.router.navigate([RoutePathEnum.PROJECTS, projectId]);
    }

    public setDefaultData(data: ProjectDefaultData): void {
        this.defaultData = data;

        this.initForm();
    }
}
